import axiosInstance from 'src/utils/axios';

const BASE_URL = 'reports';

interface GetMerchantEmployeeQueryParams {
  merchantCode: string;
  programmeCode: string;
  emailAddress?: string;
  dateFrom?: string | null;
  dateTo?: string | null;
  pageSize?: number;
  pageNumber?: number;
}

function getMerchantEmployeesApi(params: GetMerchantEmployeeQueryParams) {
  return axiosInstance.get(`${BASE_URL}/customers/v1`, {
    params,
    paramsSerializer: { indexes: null },
  });
}

interface getImpactStatsParams {
  merchantCode: string;
  programmeCode?: string;
  dateFrom?: string;
  dateTo?: string;
}

function getImpactStatsApi(params: getImpactStatsParams) {
  return axiosInstance.get(`${BASE_URL}/impact/v1`, {
    params,
    paramsSerializer: { indexes: null },
  });
}

interface GenericStatsParams {
  merchantCode: string;
  programmeCode: string;
  dateFrom: string;
  dateTo: string;
}

function getAviationStatsApi(params: GenericStatsParams) {
  return axiosInstance.get(`${BASE_URL}/aviation/v1`, {
    params,
    paramsSerializer: { indexes: null },
  });
}

function getJourneyStatsApi(params: GenericStatsParams) {
  return axiosInstance.get(`${BASE_URL}/journey/v1`, {
    params,
    paramsSerializer: { indexes: null },
  });
}

export { getMerchantEmployeesApi, getImpactStatsApi, getAviationStatsApi, getJourneyStatsApi };
